<!-- Part of the SPARKL educational activity system, Copyright 2019 by Pepper Williams -->
<template><div class="k-main-wrapper k-main-wrapper-vx">
	<div v-if="!reslink_embed_mode" class="k-main-wrapper-bgd"></div>
	<div v-if="!reslink_embed_mode" v-show="sparkl_embed_banner_hidden" class="k-sparkl-embed-show-banner-btn elevation-3" role="button" tabindex="0" aria-label="Show activity banner" @click.stop="sparkl_deminimize_header" @keydown.enter.stop.prevent="sparkl_deminimize_header" @keydown.space.stop.prevent="sparkl_deminimize_header"><k-icon color="#000">fas fa-arrow-down</k-icon></div>

	<k-app-bar dense app role="banner"
		v-if="!reslink_embed_mode"
		v-show="!sparkl_embed_banner_hidden"
		class="k-app-toolbar k-app-toolbar-vx"
		:class="current_sparkl_embed_component?'k-app-toolbar-sparkl-showing':'k-app-toolbar-sparkl-not-showing'"
		:hide-on-scroll="small_screen"
		@click="toggle_favorites(false)"
	><div class="k-app-toolbar-inner-vx">
		<img
			v-if="agency_logo_img_src"
			@click="logo_clicked"
			@keydown.enter.prevent="logo_clicked"
			@keydown.space.prevent="logo_clicked"
			class="k-toolbar__logo-img-vx"
			:alt="site_config.agency_name"
			:src="agency_logo_img_src"
			role="button"
			tabindex="0"
			:aria-label="home_banner_label"
		>
		<span
			v-if="site_config.vx_banner_logo_text"
			@click="logo_clicked"
			@keydown.enter.prevent="logo_clicked"
			@keydown.space.prevent="logo_clicked"
			class="k-cureum-logo-text-vx"
			v-html="site_config.vx_banner_logo_text"
			translate="no"
			:role="agency_logo_img_src ? undefined : 'button'"
			:tabindex="agency_logo_img_src ? undefined : 0"
			:aria-label="agency_logo_img_src ? undefined : home_banner_label"
		></span>
		<!-- if viewing a subdomain, show agency name and btn to return to state-wide view -->
		<span v-if="subdomain_data" @click="logo_clicked" @keydown.enter.prevent="logo_clicked" @keydown.space.prevent="logo_clicked" class="k-cureum-subdomain-text-vx" translate="no" role="button" tabindex="0" :aria-label="`Go to ${site_config.app_name} home`">
			<div class="k-cureum-subdomain-text-inner-vx" v-html="subdomain_data.agency_name"></div>
		</span>
		<span v-if="subdomain_data" class="k-cureum-subdomain-btn-wrapper-vx">
			<k-tooltip bottom><template v-slot:activator="{on}">
				<k-btn v-on="on" icon small class="elevation-1" color="#000" style="margin-top:3px" accessible-label="Return to statewide view" @click.stop="cancel_subdomain"><k-icon>fas fa-circle-xmark</k-icon></k-btn>
			</template>Show state-wide version of {{site_config.app_name}}</k-tooltip>
		</span>

		<!-- site navigation "tabs" -->
		<!-- favorites -->
		<k-tooltip bottom><template v-slot:activator="{on}">
			<k-btn v-on="on" icon class="ml-4 k-app-toolbar-icon-btn-vx"
				v-show="toolbar_elements_showing"
				:aria-label="tab_data.favorites.title"
				@click.stop="toggle_favorites"
			><k-icon>{{tab_data.favorites.icon}}</k-icon></k-btn>
		</template>{{tab_data.favorites.title}}</k-tooltip>

		<!-- daily lessons -->
		<k-tooltip bottom><template v-slot:activator="{on}">
			<k-btn v-on="on" icon class="ml-2 k-app-toolbar-icon-btn-vx"
				v-if="show_daily_lessons"
				v-show="toolbar_elements_showing"
				:aria-label="tab_data.favorites.title"
				@click="toggle_favorites(false);show_daily_lessons_clicked()"
			><k-icon>fas fa-flag-checkered</k-icon></k-btn>
		</template>Daily Lesson Plans</k-tooltip>

		<k-btn v-for="(tab, i) in tabs" :key="tab.id" 
			v-show="toolbar_elements_showing && (tab.id!='home' && tab.id!='favorites' && tab.id!='admin')"
			text 
			class="ml-3 k-app-toolbar-menu-btn-vx"
			:class="tab.id == current_tab_id ? 'k-app-toolbar-menu-btn-vx-current' : ''"
			@click="tab_clicked(tab.id, $event)"
		>
			<k-icon class="mr-1">{{tab.icon}}</k-icon>
			{{tab.title}}
		</k-btn>

		<k-spacer/>

		<k-tooltip bottom><template v-slot:activator="{on}"><k-btn v-on="on" v-if="alt_role_label" color="pink accent-4" class="mr-3 k-tight-btn k-nocaps-btn" dark @click="return_to_default_role"><k-icon small class="mr-2">fas fa-glasses</k-icon>{{alt_role_label}} <k-icon small class="ml-2">fas fa-arrow-rotate-left</k-icon></k-btn></template>Click to return to default role</k-tooltip>

		<!-- Sparkl btns -->
		<div v-show="current_sparkl_embed_component && viewing_original_of_in_my_collections" style="font-size:12px; border-radius:4px; background-color:rgba(255,255,255,0.8); padding:2px 6px;" class="mr-2 green--text text--darken-3">
			<k-icon color="green darken-3" small class="mr-1" style="margin-top:-3px;">fas fa-cubes-stacked</k-icon>
			<i>You are viewing the original version of an activity you copied for your use</i>
			<k-btn x-small text color="green darken-3" class="ml-1" @click="show_copy_of_original_sparkl">Show My Copy</k-btn>
		</div>
		<div v-show="current_sparkl_embed_component && viewing_copy_of_original" style="font-size:12px; border-radius:4px; background-color:rgba(255,255,255,0.8); padding:2px 6px;" class="mr-2 green--text text--darken-3">
			<k-icon color="green darken-3" small class="mr-1" style="margin-top:-3px;">fas fa-cubes-stacked</k-icon>
			<i>This activity has been copied for your use</i>
			<k-btn x-small text color="green darken-3" class="ml-1" @click="show_original_sparkl">Show Original</k-btn>
		</div>
		<!-- the following button was removed on 1/16/2026 -->
		<!-- <k-btn v-show="current_sparkl_embed_component && !viewing_original_of_in_my_collections&&show_copy_for_my_use_btn" class="k-tight-btn" color="green darken-2" dark @click.stop="copy_to_my_content($event)"><k-icon small class="mr-2">fas fa-cubes-stacked</k-icon>{{copy_to_my_content_btn_text}}</k-btn> -->
		<k-btn v-if="current_sparkl_embed_component && show_sparkl_close_btn" class="ml-2 k-tight-btn" color="amber" accessible-label="Close activity" @click.stop="sparkl_close_btn_clicked"><k-icon small class="mr-2">fas fa-times-circle</k-icon>{{ close_activity_btn_text }}</k-btn>
		<k-tooltip v-if="current_sparkl_embed_component && show_sparkl_close_btn" bottom><template v-slot:activator="{on}"><k-btn v-on="on" text small color="amber" class="ml-2" accessible-label="Minimize banner" @click="sparkl_minimize_header"><k-icon>fas fa-arrow-up</k-icon></k-btn></template><span>Minimize banner</span></k-tooltip>
		<!-- end of sparkl btns -->

		<div v-if="support_icon.enabled">
			<k-tooltip bottom>
				<template v-slot:activator="{on}">
					<k-btn v-on="on" class="k-toolbar__username mr-1" icon accessible-label="Open support" @click="support_clicked">
						<k-icon style="font-size: 28px;">{{ support_icon.icon }}</k-icon>
					</k-btn>
				</template>
				{{ support_icon.tooltip }}
			</k-tooltip>
		</div>

		<div v-if="show_pop_up_btn">
			<k-btn class="k-toolbar__username mr-2" icon accessible-label="Open site “splash screen”" @click.stop="pop_up_logo_clicked">
				<k-icon style="font-size:28px;">{{ pop_up_icon }}</k-icon>
			</k-btn>
		</div>

		<div v-if="show_toolbar_search">
			<k-tooltip bottom><template v-slot:activator="{on}">
				<k-btn v-on="on" icon class="mr-3 k-app-toolbar-icon-btn-vx"
					@click="initiate_search($event)"
					aria-label="Search"
				><k-icon>fas fa-search</k-icon></k-btn>
			</template>Search</k-tooltip>
			<!-- <k-btn class="mr-3 elevation-0" style="margin-top:0px;" fab color="#666" dark small accessible-label="Search" @click="initiate_search($event)">
				<k-icon>fas fa-search</k-icon>
			</k-btn> -->
		</div>

		<div v-if="site_config.user_guide.enabled">
			<k-tooltip bottom>
				<template v-slot:activator="{on}">
					<k-btn v-on="on" ref="help_icon" class="k-app-help-icon mr-3" icon :accessible-label="site_config.user_guide.title" @click="toggle_help">
						<k-icon large :color="site_config.user_guide.color">{{ site_config.user_guide.icon }}</k-icon>
					</k-btn>
				</template>
				{{ site_config.user_guide.tooltip }}
			</k-tooltip>
		</div>

		<UserMenuVX 
			:toolbar_elements_showing="toolbar_elements_showing"
			v-if="signed_in" 
		/>
		<k-btn v-show="toolbar_elements_showing" v-if="!signed_in&&site_config.show_banner_create_account_btn=='yes'&&!backdoor_login_only" color="#666" class="mr-3 k-tight-btn" dark @click="create_account"><k-icon small class="mr-2">fas fa-user-plus</k-icon>Create Account</k-btn>
		<k-btn v-show="toolbar_elements_showing" v-if="!signed_in&&site_config.show_banner_signin_btn=='yes'&&$vuetify.breakpoint.smAndUp&&!backdoor_login_only" :color="signin_btn_color" @click="sign_in">  Sign In<k-icon small class="mx-2">fas fa-sign-in</k-icon></k-btn>
	</div></k-app-bar>

	<div data-main-focus-start="true" tabindex="-1">
		<keep-alive><router-view :key="router_key"></router-view></keep-alive>
	</div>

	<StandardsHomeSatchel v-if="site_config.use_vx_nav" v-show="standards_home_showing" />

	<div v-if="!reslink_embed_mode" class="k-copyright">
		{{ site_config.copyright_text }} &nbsp; (v{{$store.state.app_version}})
		<span v-if="site_config.show_terms_of_service" class="ml-6">
			<!-- <k-btn x-small text class="k-tight-btn k-nocaps-btn" color="#ccc" @click="show_terms_of_service">Terms of Use / Privacy Policy</k-btn> -->
			<a class="k-copyright__link" @click="show_terms_of_service">Terms of Use / Privacy Policy</a>
		</span>
	</div>
</div></template>

<script>
import { mapState, mapGetters } from 'vuex'
import UserMenuVX from './UserMenuVX'
import StandardsHomeSatchel from './../standards/StandardsHomeSatchel'

export default {
	components: { UserMenuVX, StandardsHomeSatchel },

	data() { return {
		sparkl_embed_banner_hidden: false,
		standards_home_showing: false,
	}},

	computed: {
		...mapState(['user_info', 'site_config', 'current_sparkl_embed_component', 'subdomain_data']),
		...mapGetters(['small_screen', 'signed_in', 'backdoor_login_only', 'show_daily_lessons']),


		tab_data() {
			let customized_tabs = this.site_config.customized_tabs

			let defaults = {
				home: {
					id: 'home',
					icon: customized_tabs.home?.icon || (this.role === 'parent' ? 'fa-home-user' : 'fa-home'),
					title: customized_tabs.home?.title || `${this.site_config.app_name} Home`
				},
				classes: {
					id: 'classes',
					icon: customized_tabs.classes?.icon || 'fas fa-chalkboard',
					title: customized_tabs.classes?.title || 'Courses'
				},
				resourcerepos: {
					id: 'resourcerepos',
					icon: customized_tabs.resourcerepos?.icon || 'fas fa-diagram-project',
					title: customized_tabs.resourcerepos?.title || this.site_config.resourcerepos_noun
				},
				pd: {
					id: 'pd',
					icon: customized_tabs.pd?.icon || 'fas fa-user-graduate',
					title: customized_tabs.pd?.title || 'Professional Development'
				},
				mycollections: {
					id: 'mycollections',
					icon: customized_tabs.mycollections?.icon || 'fas fa-cubes-stacked',
					title: customized_tabs.mycollections?.title || 'My Content Collections'
				},
				standards: {
					id: 'standards',
					icon: customized_tabs.standards?.icon || 'fas fa-map',
					title: customized_tabs.standards?.title || 'Standards'
				},
				admin: {
					id: 'admin',
					icon: customized_tabs.admin?.icon || 'fas fa-cog',
					title: customized_tabs.admin?.title || 'Site Admin Tools'
				},
				favorites: {
					id: 'favorites',
					icon: customized_tabs.favorites?.icon || 'fas fa-bookmark',
					title: customized_tabs.favorites?.title || 'Favorite Collections'
				},
			}

			Object.keys(defaults).forEach(tab => {
				switch(tab) {
					case 'admin':
						// don't show admin tab on small screens
						if (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm || (this.role != 'admin' && !vapp.has_admin_right('subdomain_admin'))) {
							delete defaults.admin
						}
						break
					case 'mycollections':
						if (!(this.signed_in || this.site_config.show_mycollections_when_not_signed_in == 'yes') || this.studentish_role) {
							delete defaults.mycollections
						}
						break
					default:
						if (!this.main_tabs_to_include.includes(tab)) {
							delete defaults[tab]
						}
				}
			})

			return defaults
		},

		tabs() {	
			return Object.values(this.tab_data)
		},

		main_tabs_to_include() {
			if (this.site_config.main_tabs_to_include_vx != 'all') return this.site_config.main_tabs_to_include_vx
			return ['home', 'favorites', 'classes', 'resourcerepos', 'mycollections', 'standards']
		},

		role() { return this.user_info.role },

		signin_btn_color() { return this.site_config.banner_signin_btn_color },

		simulated_role: {
			get() { return this.$store.state.lst.simulated_role },
			set(val) { this.$store.commit('lst_set', ['simulated_role', val]) }
		},

		simulated_user: {
			get() { return this.$store.state.lst.simulated_user },
			set(val) { this.$store.commit('lst_set', ['simulated_user', val]) }
		},

		alt_role_label() {
			if (this.simulated_role) {
				if (this.role == 'student') return 'STUDENT View'
				if (this.role == 'parent') return 'GUARDIAN View'
				if (this.role == 'staff') return 'STAFF View'
			} else if (this.simulated_user) {
				return 'MIMICKING ' + this.simulated_user
			}
		},

		main_mode() {
			let path = this.$route.fullPath
			return path.replace(/^\/(\w+).*/, '$1')
		},

		agency_logo_img_src() {
			if (this.site_config.vx_banner_logo) return this.site_config.vx_banner_logo
			if (this.site_config.agency_logo) return this.site_config.agency_logo
			return ''
		},

		home_banner_label() {
			return `Go to ${this.site_config.app_name} home`
		},

		router_key() {
			let path = this.$route.fullPath
			// by using these keys, we preserve the right amount of "history" in our components...
			if (vapp.$route.name == 'collection_view') {
				return path.replace(/(\/collection\/.+?)(\/|$).*/, '$1')
			} else {
				return path
			}
		},
		
		toolbar_elements_showing() {
			// don't show most toolbar elements if we're in the reslink view, a the standalone lesson view, or are currently showing a sparkl activity
			if (this.in_reslink_view) return false
			if (this.in_standalone_lesson_view) return false
			if (this.current_sparkl_embed_component) return false
			return true
		},

		show_pop_up_btn() { 
			if (!this.toolbar_elements_showing) return false
			// show the home btn in the banner if site_config.show_pop_up is on...
			if (this.site_config.show_pop_up == true) return true
			return false
		},

		show_toolbar_search() { 
			if (!this.toolbar_elements_showing) return false
			if (this.site_config.hide_toolbar_search == 'yes') return false
			return true
		},

		pop_up_icon() {
			return this.site_config.pop_up?.icon || 'fas fa-home'
		},

		support_icon() {
			return this.site_config.support_icon
		},

		current_tab_id() {
			let rp = this.$route.path
			if (rp.includes('/standards')) return 'standards'
			if (rp.includes('/courses')) return 'classes'
			if (rp == '/repos') return 'resourcerepos'
			if (rp == '/pd') return 'resourcerepos'
			if (rp == '/mycollections') return 'mycollections'
			if (rp.includes('/standards')) return 'standards'
			if (rp.search(/^\/collection\/(.*?)\//) == 0) {
				let course_code = RegExp.$1
				let collection = this.$store.state.all_courses.find(x=>x.course_code == course_code)
				if (!empty(collection)) {
					let ct = collection.collection_type
					if (ct == 'course') return 'classes'
					if (ct == 'repo' || ct == 'pd') return 'resourcerepos'
					if (ct == 'my') return 'mycollections'
				}
			}
			return ''
		},

		// from SparklEmbed
		viewing_original_of_in_my_collections() { return this.current_sparkl_embed_component?.viewing_original_of_in_my_collections },
		viewing_copy_of_original() { return this.current_sparkl_embed_component?.viewing_copy_of_original },
		show_sparkl_close_btn() { 
			// if we're in reslink view, don't show the close btn
			if (this.in_reslink_view) return false
			return this.current_sparkl_embed_component?.show_close_btn 
		},
		show_copy_for_my_use_btn() { return this.current_sparkl_embed_component?.show_copy_for_my_use_btn },
		// copy_to_my_content_btn_text() { return this.current_sparkl_embed_component?.copy_to_my_content_btn_text },	// not used as of 1/16/2026
		close_activity_btn_text() { return this.current_sparkl_embed_component?.close_activity_btn_text },

		in_reslink_view() { return vapp.in_reslink_view },
		in_standalone_lesson_view() { return vapp.in_standalone_lesson_view },
		reslink_embed_mode() { return vapp.reslink_embed_mode },
	},
	watch: {
		'$route.path': {immediate: true, handler(val) {
			// console.warn('MainView route watcher: route ' + this.$route.path)
		}},
	},

	created() {
		window.main_view = this
	},
	
	methods: {
		// from SparklEmbed
		show_original_sparkl() { this.current_sparkl_embed_component.show_original_sparkl() },
		show_copy_of_original_sparkl() { this.current_sparkl_embed_component.show_copy_of_original_sparkl() },
		copy_to_my_content($event) { this.current_sparkl_embed_component.copy_to_my_content($event, 'force_copy') },
		use_with_students() { this.current_sparkl_embed_component.use_with_students() },
		sparkl_close_btn_clicked() { this.current_sparkl_embed_component.close_btn_clicked() },
		sparkl_minimize_header() { 
			this.sparkl_embed_banner_hidden = true
			this.current_sparkl_embed_component.sparkl_embed_banner_hidden = true
		},
		sparkl_deminimize_header() {
			this.sparkl_embed_banner_hidden = false
			this.current_sparkl_embed_component.sparkl_embed_banner_hidden = false
		},

		cancel_subdomain() { 
			this.toggle_favorites(false)
			vapp.cancel_subdomain() 
		},

		async logo_clicked() {
			// if a sparkl activity is showing and we're not in the reslink view, close it...
			if (vapp.$refs.sparkl_embed.sparkl_showing && !this.in_reslink_view) {
				this.sparkl_close_btn_clicked()
				return
			}

			// else if we're showing the standalone lesson or resource view...
			if (this.in_reslink_view || this.in_standalone_lesson_view) {
				// if we're signed in and we haven't yet loaded_classes, we need to call get_classes to interact with the rest of cureum
				if (this.signed_in && !this.$store.state.loaded_classes) {
					await this.$store.dispatch('get_classes')
				}
				
				// call a service to find out what collection and unit the asset lives in
				if (this.$route.path.search(/(lesson|reslink)\/([^\/]+)/) > -1) {
					let payload = {
						asset_id: RegExp.$2,
						asset_type: ((RegExp.$1 == 'lesson') ? 'lesson' : 'resource'),
					}

					U.loading_start()
					let ajax_result = await U.ajax_promise('get_route_for_standalone_cureum_link', payload)
					U.loading_stop()
					if (!empty(ajax_result.course_code)) {
						// we found the course/unit, so open it
						let route = `/collection/${ajax_result.course_code}/${ajax_result.unit_id}`
						console.log(route)

						this.$router.push({path: route})
						return
					}
				}
			}

			// if we get to here, go to the site home page
			vapp.go_to_home()
		},

		support_clicked() {
			this.$router.push({path: '/support'})
		},

		toggle_help() {
			vapp.toggle_help()
		},

		pop_up_logo_clicked() {
			this.toggle_favorites(false)
			vapp.show_pop_up = true
		},

		return_to_default_role() {
			// if we're in "sandbox" mode, call simulate_sandbox_role
			if (this.site_config.enable_sandbox_simulate_role_menu == 'yes') {
				vapp.simulate_sandbox_role('')

			} else {
				// otherwise just reset simulated role/user and reload
				this.simulated_role = ''
				this.simulated_user = ''
				window.location.reload()
			}
		},

		toggle_favorites(val) {
			vapp.toggle_favorites(val)
		},

		tab_clicked(tab_id, event) {
			if (tab_id == 'home') this.go_to_route('home', event)
			else if (tab_id == 'classes') this.go_to_route('courses', event)
			else if (tab_id == 'standards') this.go_to_route('standards', event)
			// else if (tab_id == 'resourcerepo') this.go_to_route('trl', event)
			else if (tab_id == 'admin') this.go_to_route('admin', event)
			else if (tab_id == 'resourcerepos') this.go_to_route('repos', event)
			else if (tab_id == 'mycollections') this.go_to_route('mycollections', event)
			else if (tab_id == 'resource_usage') this.go_to_route('resource_usage', event)
			else if (tab_id == 'pd') this.go_to_route('pd', event)
		},

		go_to_route(new_route, event) {
			if (!empty(event) && !empty(event.target)) $(event.target).closest('button').blur()
			this.toggle_favorites(false)

			new_route = '/' + new_route
			if (this.$route.path == new_route) return

			this.$router.push({ path: new_route })
		},

		sign_out() {
			// for demo purposes we sign out by clearing password from local_storage and reloading
			U.local_storage_set('district_portal_login_password', '')
			window.location.reload()

			// this.$store.dispatch('sign_out')
		},

		show_change_log() {
			this.go_to_route('changelog')
		},

		cycle_bgd_image() {
			vapp.show_bgd_image(-1)
		},

		sign_in() {
			this.toggle_favorites(false)
			vapp.redirect_to_login()
		},

		create_account() {
			vapp.redirect_to_login('create_account')
		},

		initiate_search(event) {
			this.toggle_favorites(false)
			vapp.initiate_search({
				search_only: true,
				dialog_title: 'Search Site Content',
				default_source: 'site',
				focusOriginEl: event?.currentTarget || document.activeElement,
			})
		},

		show_terms_of_service() { vapp.show_terms_of_service() },
		show_daily_lessons_clicked() { vapp.daily_lessons_showing = true },
	}
}
</script>

<style lang="scss">
.k-main-wrapper-vx {

	.k-app-toolbar-vx {
		box-shadow:none!important;
		border-bottom:1px solid rgba(255,255,255,0.1)!important;
		overflow-x: auto;
		overflow-y: hidden;
		// border-bottom:1px solid #fff!important;

		.k-app-toolbar-inner-vx {
			width:100%;
			max-width:$k-max-content-width;
			display:flex;
			align-items: center;
			margin-left: auto;
			margin-right: auto;		
		}
		
		.k-toolbar__logo-img-vx {
			height:48px;
			padding:6px 0;
		}
		.k-cureum-logo-text-vx {
			margin-left:8px;
			cursor:pointer;
		}

		// set via site_config.banner_subdomain_css
		.k-cureum-subdomain-text-vx {
			// display:inline-block;
			font-weight: bold;
			color:#fff;
			// font-size: 14px;
			// line-height:17px;
			margin-left: 12px;
			background-color:#fff;
			color:#000;
			padding:0px 4px 0 6px;
			border-radius:6px 0 0 6px;
			cursor: pointer;

			display: flex;
			align-items: center; /* Centered by default for single-line */
			height: 34px;
			overflow: hidden;    /* Prevents wrapped text from spilling out */
		}
		.k-cureum-subdomain-text-inner-vx {
			display: inline-block;
			vertical-align: middle;
			font-size: 14px;
			line-height:17px;
			max-height: 34px;    /* Ensures it doesn't push past the container */
		}
		.k-cureum-subdomain-btn-wrapper-vx {
			display:inline-block;
			height:34px;
			background-color:#fff;
			border-radius:0 6px 6px 0;
			padding-right:4px;
		}

		.k-app-toolbar-icon-btn-vx {
			color:#fff;
			width:40px!important;
			height:40px!important;
			.v-icon {
				font-size:24px!important;
			}
			// this deals with the CPS home icon
			.k-svg-icon {
				width:32px!important;
				height:32px!important;
				font-size:32px!important;
			}
		}

		.k-app-toolbar-menu-btn-vx {
			color:#fff;
			padding-left:8px;
			padding-right:8px;
			letter-spacing:normal;
			text-transform: none;
			.v-btn__content {
				padding-bottom:2px;
				border-bottom:2px solid transparent;
			}
			.v-icon {
				font-size:20px!important;
			}
		}

		.k-app-toolbar-menu-btn-vx-current {
			.v-btn__content {
				padding-bottom:2px;
				border-bottom:2px solid #fff;
			}
		}

		.k-app-toolbar-user-menu-btn-vx {
			color:#000;
			padding-left:8px;
			padding-right:8px;
			letter-spacing:normal;
			text-transform: none;

			.v-icon {
				font-size:28px!important;
			}
		}
	}

	.k-home-home-wrapper {
		max-width:1000px!important;
	}

	// note that in the 5/2026 navigation scheme, we use this as a wrapper for most top-level components,
	// not just collections
	.k-main-collection {
		max-width:$k-max-content-width;
		margin:20px auto 48px auto;
		// border:solid #000;
		// border-width:0 8px 8px 8px;
		border-width:0;
		// border-radius:0 0 10px 10px;
		border-radius:10px;
		// box-shadow:0px 0px 2px #ccc;
		box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12) !important;
	}

	.k-standards-home-wrapper-outer {
		position:absolute;
		z-index:4;
		width:100vw;
	}
	.k-standards-home-wrapper {
		margin:12px auto 0 auto;
		height:calc(100vh - 72px);
		// height:calc(100vh - 80px);
		margin-bottom:0;
		border:8px solid #222;
		border-radius:18px;
		
		.k-standards-home-iframe {
			width:100%;
			// height:calc(100vh - 56px);
			height:100%;
			// border-radius:0 0 10px 10px;
			border-radius:10px;
		}
	}

	.k-collections-view-wrapper {
		border:8px solid transparent;
		border-radius:10px;
		// border:solid transparent;
		// border-width:0 8px 8px 8px;
		// border-radius:0 0 10px 10px;
		// box-shadow:0px 0px 2px #ccc;
		box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12) !important;

		max-width:$k-max-content-width!important;
		padding:16px!important;
		margin-top:20px!important;

		.k-collections-view-wrapper-inner {
		}
	}

	@media (max-width: 1300px) {
		.k-main-collection:not(.k-home-home-wrapper) {
			border-radius:0;
			margin-top:0;
			border-width:0;
		}

		.k-standards-home-wrapper {
			border-top:4px solid #222!important;
			height:calc(100vh - 48px);
			.k-standards-home-iframe {
				border-radius:0;
			}
		}

		.k-collections-view-wrapper:not(.k-collections-view-wrapper-layout-tree) {
			margin-top:0!important;
			border-left:0px;
			border-right:0px;
			border-radius:0px;
		}
	}

	.k-collections-view-wrapper.k-collections-view-wrapper-layout-tree {
		max-width:1200px!important;
	}

	@media (max-width: 1200px) {
		.k-collections-view-wrapper.k-collections-view-wrapper-layout-tree {
			margin-top:0!important;
			// border-top:0px;
			border-left:0px;
			border-right:0px;
			border-radius:0px;
		}
	}

	@media (max-width: 1000px) {
		.k-home-home-wrapper {
			border-radius:0;
			margin-top:0;
		}
	}

}

</style>
